import { Button, Box } from "@mui/material";
import { Plus } from "lucide-react";

interface AddBtnProps {
    onClick: () => void;
    disabled?: boolean;
    label: string;
    size?: 'small' | 'medium';
}

const AddBtn: React.FC<AddBtnProps> = ({ onClick, disabled, label, size = 'medium' }) => {
    return (
        <Button
            variant="contained"
            color="primary"
            disabled={disabled}
            size={size}
            onClick={() => onClick()}
            sx={{
                color: '#fff', 
                backgroundColor: 'var(--color-primary)', 
                display: 'flex', 
                alignItems: 'center', 
                gap: 1,
                ...(size === 'small' && { height: 32, py: 0, fontSize: 13, boxShadow: 'none' }),
                '&:hover': { backgroundColor: 'var(--color-primary)' } 
            }}
        >
            <Box sx={{ 
                width: size === 'small' ? 16 : 20, 
                height: size === 'small' ? 16 : 20, 
                borderRadius: '50%', 
                background: 'var(--color-page-background)', 
                display: 'flex', 
                alignItems: 'center', 
                justifyContent: 'center' }}
            >
                <Plus size={size === 'small' ? 13 : 16} color="var(--color-primary)"/>
            </Box>
            {label}
        </Button>
    );
}
export default AddBtn;